import React, { FC } from 'react';
import { font as initialFont } from '@styles/fonts';
import { scale as initialScale } from '@components/frame';
import { NCFileBatchEventsProps } from '@v2/pages/common/components/NCFileBatchEvents';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

interface EventErrorDisplayProp extends Pick<NCFileBatchEventsProps, 'C' | 'font' | 'scale'> {
  error: Error | null;
}

const EventErrorDisplay: FC<EventErrorDisplayProp> = ({ error, C, scale = initialScale, font = initialFont }) => {
  if (!error) return null;

  return (
    <View style={[{ alignItems: 'center', justifyContent: 'center', paddingTop: scale(20) }]}>
      <Text style={[font.Body, { color: C('Label/Light/Red') }]}>
        {i18n.t('errorLoadingData')}: {error.message}
      </Text>
    </View>
  );
};

export default EventErrorDisplay;
